(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-dropdown"] && !Shopify.designMode) return;
  try {
    // Immediately attach mousemove listener to capture first movement even before DOMContentLoaded
  (function () {
    function enableHover() {
      const wrapper = document.querySelector('.mega-wrapper');
      if (wrapper) {
        wrapper.classList.add('hover-enabled');
      }
    }
    document.addEventListener('mousemove', enableHover, { once: true });
  })();

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.mega-wrapper');
    if (!wrapper) return;

    const dropdown = wrapper.querySelector('.mega-dropdown');
    if (!dropdown) return;

    // Level 1 hover (category)
    const categories = wrapper.querySelectorAll('.mega-category-item');
    categories.forEach((item, index) => {
      item.addEventListener('mouseenter', function () {
        wrapper.querySelectorAll('.mega-category-item').forEach((el) => el.classList.remove('active'));
        wrapper.querySelectorAll('.mega-sub-content').forEach((el) => el.classList.remove('active'));
        item.classList.add('active');
        const target = document.getElementById('mega-' + (index + 1));
        if (target) target.classList.add('active');
      });
    });

    // Level 2 hover (sub-category)
    wrapper.querySelectorAll('.mega-sub-item').forEach((item) => {
      item.addEventListener('mouseenter', function () {
        const parent = item.closest('.mega-sub-content');
        if (!parent) return;
        parent.querySelectorAll('.mega-sub-item').forEach((el) => el.classList.remove('active'));
        parent.querySelectorAll('.mega-product-panel').forEach((el) => el.classList.remove('active'));
        item.classList.add('active');
        const targetId = item.getAttribute('data-product');
        const targetPanel = parent.querySelector('#' + targetId);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
